import { Typography, Drawer, Descriptions } from "antd"
import React, { useState } from "react"

const { Link } = Typography

export default function ViewOrderDetailsModal({ props }) {
  const [open, setOpen] = useState(false)
  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Link onClick={showDrawer}>{props.code}</Link>
      <Drawer title="Plate Info" placement="left" onClose={onClose} open={open}>
        <Descriptions column={1}>
          <Descriptions.Item label="Client">{props.client}</Descriptions.Item>
          <Descriptions.Item label="Code">{props.code}</Descriptions.Item>
          <Descriptions.Item label="Comment">{props.comment}</Descriptions.Item>
          <Descriptions.Item label="Knife Number - Rows">{props.knifeNumberRows}</Descriptions.Item>
          <Descriptions.Item label="Layout Name">{props.layoutName}</Descriptions.Item>
          <Descriptions.Item label="Product">{props.product}</Descriptions.Item>
          <Descriptions.Item label="Width X Height">{props.widthXHeight}</Descriptions.Item>
        </Descriptions>
      </Drawer>
    </div>
  )
}
